import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-4 pb-6 px-4 bg-gradient-to-b from-purple-50 via-pink-50 to-amber-50 text-center" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        <div className="inline-block bg-yellow-300 text-black font-bold px-4 py-1 rounded-full text-sm mb-3 transform -rotate-1 shadow-sm" data-id="element-86">
          🔥 CUPOS DIGITALES LIMITADOS
        </div>

        <h2 className="text-xl md:text-2xl text-gray-600 font-medium mb-1" data-id="element-87">
          Para mamás y papás con hijos niños y adolescentes
        </h2>

        <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-3 leading-tight" data-id="element-88">
          <span className="text-green-600" data-id="element-89">PACK DIGITAL</span>
          <br data-id="element-90" />
          CREANDO RECUERDOS REALES
        </h1>

        <p className="text-xl md:text-2xl text-gray-700 mb-4 font-serif italic" data-id="element-91">
          Momentos simples que tus hijos recordarán toda la vida
        </p>

        <div className="mb-4 transform hover:scale-105 transition-transform duration-300" data-id="element-92">
          <a href="#compra" data-id="element-93">
            <img src="https://cdn.magicpatterns.com/uploads/iYsvA7oBLAymZBsGUQGcVm/mockup.png" alt="Pack Digital Creando Recuerdos Reales" className="mx-auto rounded-lg shadow-2xl border-4 border-white max-w-md w-full" data-id="element-94" />
          </a>
        </div>

        <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-95">
          Sin pantallas. Sin estrés. Sin culpa.
        </h3>

        <CTAButton text="👉 SÍ, QUIERO EMPEZAR HOY" subtext="Acceso inmediato - Garantía de 7 días" data-id="element-96" />

        <div className="mt-2 flex justify-center items-center gap-2 text-sm text-gray-500" data-id="element-97">
          <span className="flex items-center gap-1" data-id="element-98">
            ✅ Garantía de satisfacción de 7 días
          </span>
        </div>
      </div>
    </section>;
}